import { useTranslation } from 'react-i18next';

import FeedHeader, { FeedHeaderProps, FeedViewAllFooter } from './feed-header';
import { Content } from '../../../models/content/types';
import './content-layouts.scss';
import { FeedCardWithData } from '../../content/solar-feed-card/solar-feed-card';
import {
  FeedCardGrid,
  FeedCardGridItem,
} from '@socialchorus/shared-ui-components';
import useScreenSize from '../../../common/use-screen-size';
import useFeatureFlag from '../../../common/use-feature-flag';
import { Feature } from '../../../models/features/features';
import { MobileHorizontalFeedCards } from './horizontal-scroll-row';

type ContentLayoutHeroProps = FeedHeaderProps & {
  contents: Content[];
  description?: string;
  feedUrl: string;
  viewAllText: string;
  isTopic: boolean;
};

const ContentLayoutHero = ({
  id,
  contents,
  analyticsData,
  title,
  description,
  feedUrl,
  viewAllText,
  isTopic = false,
}: ContentLayoutHeroProps) => {
  const heroContent = contents[0];
  const sidecardContents = contents.slice(1, 4);
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();
  const mobileWebParity = useFeatureFlag(
    Feature.CUSTOM_HOMEPAGE_MOBILE_WEB_PARITY
  );

  return (
    <>
      <FeedHeader
        id={id}
        title={title}
        description={description}
        viewAllLink={feedUrl}
        viewAllText={viewAllText || `${t('assistant.view_all')} ${title}`}
        analyticsData={analyticsData}
        isTopic={isTopic}
        isMobileHorizontal={isMobile && !!mobileWebParity}
      />

      {isMobile && mobileWebParity ? (
        <>
          <MobileHorizontalFeedCards
            contents={contents}
            analyticsData={analyticsData}
            title={title}
          />
          {feedUrl && (
            <FeedViewAllFooter
              viewAllLink={feedUrl}
              viewAllText={viewAllText || `${t('assistant.view_all')} ${title}`}
              isTopic={isTopic}
              analyticsData={analyticsData}
            />
          )}
        </>
      ) : (
        <FeedCardGrid columns={isMobile ? 1 : 2}>
          <FeedCardGridItem rowSpan={3}>
            <FeedCardWithData
              content={heroContent}
              analyticsData={analyticsData}
              compact
              fullHeight
              layout="vertical"
              titleHeadingLevel={2}
              lineClamp={5}
              inlineVideo={true}
            />
          </FeedCardGridItem>
          {sidecardContents.map((content) => (
            <FeedCardGridItem key={content.id}>
              <FeedCardWithData
                content={content}
                analyticsData={analyticsData}
                compact
                fullHeight
                layout="horizontal"
                titleHeadingLevel={2}
              />
            </FeedCardGridItem>
          ))}
        </FeedCardGrid>
      )}
    </>
  );
};

export default ContentLayoutHero;
